import * as React from 'react';
import styled from 'styled-components';
import { useState } from 'react';
import ContentConstants from '../../../contentConstants';
import { AudienceSourceType, DistributionType, UserType } from '../../../models';
import { useDispatch, useSelector } from 'react-redux';
import { IApplicationState } from '../../../store';
import { ActionCreators as AudienceDetailsActionCreators } from '../../../store/AudienceDetailsStore';
import { ClearDiv } from '@aon/aon-tws-common-ui';

export const RogTab = styled.span.attrs<any, any>({
	className: 'tws-rog-tab',
	'data-testid': 'tws-rog-tab',
})`
	cursor: pointer;
	display: inline-block;
	border-bottom: 1px solid #2a9fd8;
	padding: 10px 28px;

	&.active {
		border-bottom: 3px solid #2a9fd8;
		font-weight: 700;
	}
`;

export const DistributionTypeOptions = () => {
	const { audienceSourceType } = useSelector((state: IApplicationState) => state.survey.surveyEditModel.survey);
	const { distributionType } = useSelector((state: IApplicationState) => state.audienceDetails.audience);
	const { user } = useSelector((state: IApplicationState) => state.oidc);
	const [activeKey, SetActiveKey] = useState(distributionType);
	const dispatch = useDispatch();

	const onTabClick = (selectedDistType: DistributionType) => {
		SetActiveKey(selectedDistType);
		return dispatch(AudienceDetailsActionCreators.HandleDistributionTypeChange(selectedDistType));
	};

	return (
		<>
			<ClearDiv>
				{(audienceSourceType === AudienceSourceType.FileUpload || audienceSourceType === AudienceSourceType.Hris) && (
					<RogTab
						className={activeKey === DistributionType.SingleLinkWithoutDistribution ? 'active' : ''}
						onClick={() => onTabClick(DistributionType.SingleLinkWithoutDistribution)}
					>
						{ContentConstants.DISTRIBUTIONOPTIONS_SINGLE_LINK_USER_TITLE}
					</RogTab>
				)}
				<RogTab
					className={activeKey === DistributionType.SingleLink ? 'active' : ''}
					onClick={() => onTabClick(DistributionType.SingleLink)}
				>
					{ContentConstants.DISTRIBUTIONOPTIONS_SINGLE_LINK_SYSTEM_TITLE}
				</RogTab>
				<RogTab className={activeKey === DistributionType.Unique ? 'active' : ''} onClick={() => onTabClick(DistributionType.Unique)}>
					{ContentConstants.DISTRIBUTIONOPTIONS_UNIQUE_LINK_TITLE}
				</RogTab>
				<RogTab
					className={activeKey === DistributionType.SingleLinkWithAccessCode ? 'active' : ''}
					onClick={() => onTabClick(DistributionType.SingleLinkWithAccessCode)}
				>
					{ContentConstants.DISTRIBUTIONOPTIONS_SINGLE_LINK_WITH_ACCESS_CODES_TITLE}
				</RogTab>
				{user?.profile.userType === UserType.Internal &&
					(audienceSourceType === AudienceSourceType.FileUpload || audienceSourceType === AudienceSourceType.Hris) && (
						<RogTab className={activeKey === DistributionType.SSO ? 'active' : ''} onClick={() => onTabClick(DistributionType.SSO)}>
							{ContentConstants.DISTRIBUTIONOPTIONS_SSO_TITLE}
						</RogTab>
					)}
			</ClearDiv>
		</>
	);
};
